import { useMemo } from 'react';
import {
    PieChart, Pie, Cell, ResponsiveContainer,
} from 'recharts';
import { Typography, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { TITLE_TXT } from '../../../constants/constants';

const { Title } = Typography;

const CHART_COLORS = ['#f5473a', '#4f7ae8', '#2f53d2', '#223f9e', '#f68d3f'];

const IndustriesChart = ({ dashboardData }) => {
    const totalIndustryAmount = useMemo(
        () =>
            (dashboardData?.industryDetails?.AllIndustryDetails || []).reduce(
                (sum, item) => sum + Number(item?.totalAmount || 0),
                0
            ),
        [dashboardData]
    );

    const sourceData = useMemo(
        () =>
            (dashboardData?.industryDetails?.AllIndustryDetails || []).map(
                (item, index) => {
                    const amount = Number(item?.totalAmount || 0);

                    return {
                        id: item?.industry_type_id,
                        name: item?.industryTypeName,
                        value: amount,
                        percent:
                            totalIndustryAmount > 0
                                ? Math.round((amount / totalIndustryAmount) * 100)
                                : 0,
                        fill: CHART_COLORS[index % CHART_COLORS.length],
                    };
                }
            ),
        [dashboardData, totalIndustryAmount]
    );

    const hasMeaningfulData =
        (dashboardData?.industryDetails?.AllIndustryDetails || []).length > 0
        && totalIndustryAmount > 0;

    return (
        <div className='industries-invested-container'>
            <div className='industries-header-container'>
                <Title level={4}>
                    {TITLE_TXT.IND_INV}
                    <Tooltip title="Breakdown of your investments across different industries."><InfoCircleOutlined className='industry-info-icon' /></Tooltip>
                </Title>
            </div>
            <div className='industries-charts-container'>
                {hasMeaningfulData ? (
                    <div className='industries-content-layout'>
                        <div className='donut-wrapper'>
                            <ResponsiveContainer width='100%' height={320}>
                                <PieChart>
                                    <Pie
                                        data={sourceData}
                                        dataKey='value'
                                        nameKey='name'
                                        cx='50%'
                                        cy='50%'
                                        innerRadius={88}
                                        outerRadius={120}
                                        startAngle={90}
                                        endAngle={-270}
                                        stroke='none'
                                    >
                                        {sourceData.map((entry, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={entry.fill}
                                            />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>

                            <div className='donut-center-text'>
                                <h2>{dashboardData?.totalDealsInvested || 0}</h2>
                                <p>Total Deals</p>
                            </div>

                            <p className='donut-caption'>
                                Deals Distribution
                            </p>
                        </div>

                        <div className='industries-legend-wrap'>
                            {sourceData.map((item) => (
                                <div
                                    key={item.id}
                                    className='industries-legend-item'
                                >
                                    <span className='legend-industry-name'>
                                        <i style={{ backgroundColor: item.fill }} />
                                        {item.name}
                                    </span>

                                    <span className='legend-value'>
                                        ₹{item.value.toLocaleString('en-IN')}
                                    </span>

                                    <span className='legend-percent'>
                                        ({item.percent}%)
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className='no-data-container'>
                        No industry investment data available
                    </div>
                )}
            </div>
        </div>
    );
};

export default IndustriesChart;
